import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, Input, OnInit, Signal} from '@angular/core';
import {MediaQueryService} from "../../services/media-query/media-query.service";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {DialogComponent} from "../../shared/toolbox/dialogs/dialog/dialog.component";
import {RxAuthService} from "../../services/rx-auth/rx-auth.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-sector-profile',
  templateUrl: './sector-profile.component.html',
  styleUrls: ['./sector-profile.component.scss']
})
export class SectorProfileComponent implements AfterViewInit, OnInit {

  constructor(
    public auth: RxAuthService,
  ) {
  }

  @Input() sectorProfile: any = {}

  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  public isMobile: Signal<boolean> = toSignal(
    this.mediaQueryService.getDisplayType().pipe(
      map(({isMobile}) => isMobile)),
    {initialValue: window.innerWidth < 767}
  );

  showdata = false;

  ngOnInit() {
    if (!this.auth.isStaffUser()) {
      window.location.href = environment.wp.frontend_base
    }

  }

  ngAfterViewInit() {
  }
}
